import React, { useEffect, useState } from 'react';

import { Route, Switch } from 'react-router';
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
//import { Switch } from "react-router-dom";
import { Layout } from './components/Layout';
import Home from './components/Home';
import Quotation from './components/Quotation';
import IndemnityProposal from './components/IndemnityProposal';
import EditPopUp from './components/EditPopUp';


import './custom.css';
import { OtherLink } from './components/OtherLink';
import PaymentSuccessOrFailDumy from './components/PaymentSuccessOrFailDumy';
import axios from '../node_modules/axios/index';
import "./components/css/Header.css"
import { NavMenu } from './components/NavMenu';
import WhatsAppBot from './components/whatsappbot/WhatsAppBot';


const App = () => {

    const [IsHideDash, setDeshBoard] = useState(true);
    const [UserData, setUserData] = useState("");
    const [cookies, setCookies] = useState();
    const [showWhatsAppBot, setWhatsAppBot] = useState(false);

    useEffect(() => {
        // Cookie manipulation logic
        const cookies = document.cookie.split("; ");
        cookies.forEach((cookie) => {
            const d = window.location.hostname.split(".");
            while (d.length > 0) {
                const cookieBase =
                    encodeURIComponent(cookie.split(";")[0].split("=")[0]) +
                    "=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=" +
                    d.join(".") +
                    " ;path=";
                const p = window.location.pathname.split("/");
                document.cookie = cookieBase + "/";
                while (p.length > 0) {
                    document.cookie = cookieBase + p.join("/");
                    p.pop();
                }
                d.shift();
            }
        });

        // URL redirection logic
        let url = window.location.href;
        if (url.match("/api/Policy")) {
            if (url.match("www")) {
                url = url.replace("www.", "");
            } else {
                url = url.replace("https://", "https://www.");
            }
            window.location.href = url;
        }

        // Handling query parameters
        const prm = new URLSearchParams(window.location.search);
        if (prm.get("user") != null && prm.get("user") != undefined) {
            const d = {
                token: prm.get("user"),
            };
            window.localStorage.setItem("token", JSON.stringify(d));
        }
    }, []);


    useEffect(() => {
        const allCookies = getCookies();
        if (allCookies.priviledge) {
            try {
                const obj = JSON.parse(atob(allCookies.priviledge));
                setCookies(obj);
            } catch (error) {
                console.error('Error decoding privilege cookie', error);
            }
        }

        const token = window.localStorage.getItem("token");
        if (token) {
            const parseToken = token.charAt(0) === "{";
            const data = {
                Token: parseToken ? JSON.parse(token).token : token,
            };

            const md = {
                URL: "GetUserInfo",
                PostString: JSON.stringify(data),
            };

            axios.post("/central/centralcall/CallReqWithHeader", md)
                .then((res) => {
                    if (res.data.userID !== "Session is abort") {
                        //dispatch(setUserData(res?.data));
                        setUserData(res?.data);
                        setDeshBoard(!(res.data.roleID === 29 || res.data.roleID === 32));

                        if (res.data.userID > 0) {
                            window.localStorage.setItem("UserID", res.data.userID);
                        }
                    } else {
                        setWhatsAppBot(true);
                        window.localStorage.removeItem("token");
                    }
                });
        } else {
            setWhatsAppBot(true);
        }

        //console.log(UserData, "User Data");
    }, []);

    useEffect(() => {
        console.log(cookies, "cookies Data 2 (after state update)");
    }, [cookies]);
    const getCookies = () => {
        var cookies = document.cookie.split(';');
        var cookieMap = {};
        cookies.forEach(function (cookie) {
            var parts = cookie.split('=');
            var name = parts[0].trim();
            var value = decodeURIComponent(parts[1]);
            cookieMap[name] = value;
        });
        return cookieMap;
    };
    //useEffect(() => {
    //    if (cookies) {
    //        const hasBlockPos = cookies?.priviledgeList.some(
    //            (item) => item.PrivilegeName.toLowerCase() === "become a pos"
    //        );
    //        //console.log(hasBlockPos, "Affiliate"); // Output will be true or false
    //        setBlockPos(hasBlockPos);
    //    } else {
    //        console.log("priviledgeList is not an array or cookies is undefined");
    //    }
    //}, [cookies]);

    useEffect(() => {
        if (UserData.userID === 188452) {
            document.documentElement.style.setProperty('--Prim-Color', "#5430bb");
            document.documentElement.style.setProperty('--LightBG', "#f1f7ff");
            document.documentElement.style.setProperty('--DarkBG-BTN', "#3c17a5");
            document.documentElement.style.setProperty('--BrightnessDark', "brightness(0)");
            document.documentElement.style.setProperty('--AllImages', "grayscale(1)");
            document.documentElement.style.setProperty('--BTN-Radius', "10px");
            document.documentElement.style.setProperty('--Radio-Color', "blue");
            document.documentElement.style.setProperty('--Font-Family', "'Roboto', sans-serif");
            document.documentElement.style.setProperty('--AllImagesColor', "grayscale(0)");
        } else if (UserData.userID === 29502) {
            document.documentElement.style.setProperty('--Prim-Color', "#3F4599");
            document.documentElement.style.setProperty('--PrimeTextColor', "#161719");
            document.documentElement.style.setProperty('--SecondryTextColor', "#5F6570");
            document.documentElement.style.setProperty('--LightBG', "#eef1fabd");
            document.documentElement.style.setProperty('--DarkBG-BTN', "#30368e");
            document.documentElement.style.setProperty('--BrightnessDark', "brightness(0)");
            document.documentElement.style.setProperty('--BTN-Radius', "5px");
            document.documentElement.style.setProperty('--Radio-Color', "blue");
            document.documentElement.style.setProperty('--Font-Family', "'Poppins', sans-serif");
            document.documentElement.style.setProperty('--AllImagesColor', "grayscale(0)");
            document.documentElement.style.setProperty('--AllImagesColor1', "grayscale(1)");
            document.documentElement.style.setProperty('--ComnFontSize', "11px");
            document.documentElement.style.setProperty('--MiddFontSize', "14px");
        }
    }, [UserData]);

    return (
        <React.Fragment>
            <div className={IsHideDash === false ? "SMCbody NewUIStyle OnlyAlliance" : "SMCbody NewUIStyle"}>
                <NavMenu CoockieData={cookies} Udata={UserData} />
                {showWhatsAppBot && <WhatsAppBot />}
            <Switch>
                <Route exact path='/' component={Home}  />
                <Route path='/quotation' component={Quotation} />
                <Route path='/proposal' component={IndemnityProposal} />
                <Route path='/EditPopUp' component={EditPopUp} />
                <Route path='/OtherLink' component={OtherLink} />
                <Route path='/paymentresult' component={PaymentSuccessOrFailDumy} />
                </Switch>
            </div>
        </React.Fragment>
    );

}
export default App;
